/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React from "react";
import { NextSeo } from "next-seo";
import { isPrimaryLanguage } from "@nf/common";
import { useCountry, useLanguage } from "hooks";
import { fallbackPageMetadata } from "./pageMetadata";

export type GenreSEOProps = {
  title: string;
  description?: string;
};

export const GenreSEO = ({ title, description }: GenreSEOProps) => {
  const country = useCountry();
  const language = useLanguage();
  const seoTitle = `${process.env.NEXT_PUBLIC_NAME} | ${title}`;
  const seoDescription =
    description || fallbackPageMetadata.category.description;

  return (
    <NextSeo
      title={seoTitle}
      description={seoDescription}
      noindex={!isPrimaryLanguage(language, country)}
      openGraph={{
        title: seoTitle,
        description: seoDescription,
      }}
    />
  );
};

export default GenreSEO;
